// Context.ts
import { createContext } from 'react';
import { type AlertContextType } from './types';

const Context = createContext<AlertContextType | null>(null);

export default Context;
